import { Radio } from '@headlessui/react'
import styled from 'styled-components'

import { Location } from '@/apiTypes.ts'
import LocationSvg from '@/assets/svgs/location.svg'
import { BodyM } from '@/components/Text.tsx'
import { formatKm } from '@/utils/formatKm.ts'

const StyledLocation = styled.div`
  display: flex;
  flex-flow: row;
  align-items: flex-start;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.colors.common.border};
  border-radius: 4px;
`

const LocationImg = styled.div`
  position: relative;
  top: 3px;
  flex: 0 0 40px;
`

const LocationDetail = styled.div`
  display: flex;
  flex-flow: column;
`

const LocationDetailHeading = styled(BodyM)`
  color: ${({ theme }) => theme.colors.common.black95};
  font-weight: 500;
`

export const LocationCard = ({ location }: { location: Location }) => (
  <StyledLocation>
    <LocationImg>
      <img src={LocationSvg} alt={location.name} />
    </LocationImg>
    <LocationDetail>
      <LocationDetailHeading>
        {location.name || location.fullName}
      </LocationDetailHeading>
      <BodyM>{location.address}</BodyM>
      {location.distance && <BodyM>{formatKm(location.distance)}</BodyM>}
    </LocationDetail>
  </StyledLocation>
)

export const LocationRadio = styled(Radio)`
  display: block;
  border-radius: 4px;
  cursor: pointer;

  & + & {
    margin-top: 20px;
  }
  &[data-checked] {
    background-color: ${({ theme }) => theme.colors.common.background};
  }
`
